(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });

    document.querySelectorAll('localization-form-component').forEach((component) => {
      component.querySelectorAll('.country[data-iso]').forEach((el) => {
        try { el.textContent = displayNames.of(el.dataset.iso); } catch {}
      });

      const mainList = component.querySelector('ul.countries');
      if (mainList) {
        const items = [...mainList.querySelectorAll('li.localization-form__list-item')];
        items.sort((a, b) => {
          const nameA = a.querySelector('.country')?.textContent?.trim() ?? '';
          const nameB = b.querySelector('.country')?.textContent?.trim() ?? '';
          return nameA.localeCompare(nameB, 'en');
        });
        items.forEach(item => mainList.appendChild(item));
      }

      const popularList = component.querySelector('ul.popular-countries');
      if (popularList) {
        const items = [...popularList.querySelectorAll('li.localization-form__list-item')];
        items.sort((a, b) => {
          const nameA = a.querySelector('.country')?.textContent?.trim() ?? '';
          const nameB = b.querySelector('.country')?.textContent?.trim() ?? '';
          return nameA.localeCompare(nameB, 'en');
        });
        items.forEach(item => popularList.appendChild(item));
      }
    });

    // BG redirect
    document.querySelectorAll('#LocalizationForm').forEach((form) => {
      const originalSubmit = form.submit.bind(form);
      form.submit = function () {
        const countryInput = form.querySelector('[name="country_code"]');
        if (countryInput?.value === 'BG') {
          const bgLink = document.querySelector('link[rel="alternate"][hreflang="bg"]');
          let returnInput = form.querySelector('[name="return_to"]');
          if (!returnInput) {
            returnInput = document.createElement('input');
            returnInput.type = 'hidden';
            returnInput.name = 'return_to';
            form.appendChild(returnInput);
          }
          returnInput.value = bgLink ? new URL(bgLink.href).pathname : '/';
        }
        originalSubmit();
      };
    });

  });
  } catch(e) { console.error(e); }
})();

})();
